// Static tab definitions for the Inventory panel's two tabbed sections
// (left inventory views + right posting forms). Lifted from the
// orchestrator to keep the panel file under the file-size hygiene cap.
//
// Both arrays are pure data (no closures over component state) and are
// safe to keep at module scope -- ManufacturingTabbedSection only
// reads `id / label / description`.

export type InventoryViewTab = "materials" | "recipes" | "changelog";
export type PostingTab = "receive" | "recipeCount";

export const INVENTORY_VIEW_TABS: ReadonlyArray<{
  id: InventoryViewTab;
  label: string;
  description: string;
}> = [
  {
    id: "materials",
    label: "Materials",
    description:
      "Per-plant on-hand qty + WAC for raw materials. Edit a row to adjust costing or status.",
  },
  {
    id: "recipes",
    label: "Recipes",
    description:
      "Per-plant on-hand counts of pre-built recipes (subassemblies). Post counts in Recipe count.",
  },
  {
    id: "changelog",
    label: "Changelog",
    description:
      "Per-event timeline of material receipts and recipe counts (manual posts, adjustments, opening balances).",
  },
];

export const POSTING_TABS: ReadonlyArray<{
  id: PostingTab;
  label: string;
  description: string;
}> = [
  {
    id: "receive",
    label: "Receive lines",
    description: "Post inventory receipts to update on-hand qty and WAC.",
  },
  {
    id: "recipeCount",
    label: "Recipe count",
    description:
      "Post a count of pre-built subassemblies (e.g. 40 trusses @ $87.50 each).",
  },
];

export const ALL_POSTING_TABS: ReadonlyArray<{
  id: PostingTab;
  label: string;
  description: string;
}> = [...POSTING_TABS];
